import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { useAuthData } from 'lib-shared-auth';
import { electron } from 'lib-shared-electron';
import { useMemo } from 'react';

import { useBreakpointValue } from 'utils/mediaQuery';
import { useAppSelector } from 'utils/redux/useAppSelector';

import styles from './profileDesktopAppLink.module.scss';

export const ProfileDesktopAppLink = (): JSX.Element | null => {
  const isSmallScreen = useBreakpointValue({ base: true, md: false });

  const organization = useAppSelector(
    (state) => state.settings.organization.organization,
  );

  const authData = useAuthData();

  const appProtocol = useMemo(() => {
    return `dixa://?refreshToken=${authData?.refresh_token}&subdomain=${organization?.subdomain}`;
  }, [authData, organization?.subdomain]);

  if (electron.isElectron() || isSmallScreen) return null;

  return (
    <Text.ExternalLink href={appProtocol} className={styles.root}>
      <FlexBox alignItems="center" gap="200">
        Open Dixa App
        <Icon name="external-link" />
      </FlexBox>
    </Text.ExternalLink>
  );
};
